// /src/components/Toast.jsx
import React from "react";

export default function Toast({ open, text, type = "info", onClose }) {
  if (!open) return null;
  const p =
    {
      success: { bg: "#00723a", fg: "#fff" },
      error: { bg: "#e54848", fg: "#fff" },
      warning: { bg: "#e4b900", fg: "#222" },
      info: { bg: "#2d6cdf", fg: "#fff" },
    }[type] || { bg: "#333", fg: "#fff" };

  return (
    <div
      onClick={onClose}
      role="status"
      aria-live="polite"
      title="Натисніть, щоб закрити"
      style={{
        position: "fixed",
        right: 18,
        bottom: 18,
        zIndex: 9999,
        background: p.bg,
        color: p.fg,
        padding: "12px 16px",
        borderRadius: 12,
        boxShadow: "0 6px 22px rgba(0,0,0,.18)",
        fontWeight: 600,
        letterSpacing: ".2px",
        cursor: "pointer",
        maxWidth: 420,
        transition: "transform .2s ease, opacity .2s ease",
      }}
    >
      {text}
    </div>
  );
}
